import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import ContactForm from './ContactForm';

const Contact = () => {
  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8} className="text-center">
          <h1>Contact Me</h1>
          <p>If you have any questions or would like to get in touch, please fill out the form below.</p>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col md={8} className="mx-auto">
          <ContactForm />
        </Col>
      </Row>
      <ToastContainer />
    </Container>
  );
};

export default Contact;
